module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "submenu-padding sub-box scroll-person"
  }, [_c('div', {
    staticClass: "box-header no-padding--top"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.choose_a_theme')))])]), _vm._v(" "), _vm._l((_vm.themeList), function(theme) {
    return _c('div', {
      staticClass: "kp-modular-row clearfix",
      class: {
        select: theme.slug === _vm.themeActive.slug
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.changeTheme(theme)
        }
      }
    }, [_c('div', {
      staticClass: "media-hover"
    }, [_c('div', {
      staticClass: "theme_select"
    }, [_c('i', {
      staticClass: "icon-kp-check"
    }), _vm._v(" "), _c('a', {
      staticClass: "btn btn--inline",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.sidebarChangePanel('style');
          _vm.sidebarChangeActiveButton('style');
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.edit_theme')))])])]), _vm._v(" "), _c('img', {
      staticClass: "media-image",
      attrs: {
        "src": _vm.thumbUrl(theme.slug),
        "alt": theme.name
      }
    })])])
  })], 2)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-218e5a92!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/themes/List.vue
 ** module id = 780
 ** module chunks = 1
 **/